import { alpha, Box } from '@mui/material';
import useBundleTranslation from 'i18n';
import { useAppBuilderContext } from 'app/app/editor/context';
import { useQuery } from '@tanstack/react-query';
import { formAPI } from 'api/form';
import React from 'react';
import { findContainer } from 'app/app/editor/index.functions';

function CssComponentEditor({ componentUid }: { componentUid: string }) {
    const { t } = useBundleTranslation();
    const ctx = useAppBuilderContext();
    const [page, componentQuerySelector, sendMessage] = [ctx.page, ctx.componentQuerySelector, ctx.sendMessage];

    const component = null !== componentUid && page?.components[componentUid];
    const { status, data } = useQuery<any, Error>({
        queryKey: [component ? component.component : '', 'styles.json'],
        queryFn: () =>
            component ? formAPI.load('/data/app/components/' + component.component + '/styles.json') : null,
    });

    if (status === 'pending') return <Box>{t('loading___')}</Box>;
    else if (status === 'error') return <Box>{t('error')}</Box>;

    if (!data || !data.data || !data.data.elements || 0 === data.data.elements.length) return <></>;

    let findElement = function (el: any[]): any {
        for (let i = 0; i < el.length; i++) {
            if (el[i].querySelector == componentQuerySelector) return el[i];

            if (el[i].elements) {
                let r: any = findElement(el[i].elements);
                if (null != r) return r;
            }
        }
        return null;
    };

    let e = findElement(data.data.elements);

    return (
        <Box>
            {!componentQuerySelector && (
                <Box>
                    <CssContainerEditor componentUid={componentUid} isParent={true} />
                </Box>
            )}
            {null != e && (
                <Box>
                    {e.classes.map((c: any, k: number) => {
                        return (
                            <Box key={k}>
                                <Box>{'.' + c + '{'}</Box>

                                <Box>{'}'}</Box>
                            </Box>
                        );
                    })}
                </Box>
            )}
        </Box>
    );
}

function CssContainerEditor({ componentUid, isParent }: { componentUid: string; isParent: boolean }) {
    const ctx = useAppBuilderContext();
    const [page] = [ctx.page];

    const container = findContainer(page?.layout, componentUid, isParent);

    if (!container) return <></>;
    return (
        <Box
            component={'pre'}
            sx={{
                padding: '5px',
                backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.05),
                border: (theme) => `1px solid ${alpha(theme.palette.text.primary, 0.2)}`,
                wordBreak: 'break-all',
                wordWrap: 'break-word',
                borderRadius: '4px',
            }}
        >
            {JSON.stringify(container.params.layout, null, 2)}
        </Box>
    );
}

export default function CssEditor({ componentUid }: { componentUid: string }) {
    const ctx = useAppBuilderContext();
    const [page] = [ctx.page];

    const isComponent = null !== componentUid && undefined !== page?.components[componentUid];

    return (
        <Box>
            {!isComponent && <CssContainerEditor componentUid={componentUid} isParent={false} />}
            {isComponent && <CssComponentEditor componentUid={componentUid} />}
        </Box>
    );
}
